/** Read-only MSC master Schedule A: tier table + every rate / fee section (agent Schedule A step + admin preview). */
import React from 'react';

export function MasterTiers({ tiers, currentTier, note }) {
  return (
    <div className="space-y-2" data-testid="master-tiers">
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-5">{tiers.map((t) => (
        <div key={t.tier} className={`rounded-lg border p-3 ${t.tier === currentTier ? 'border-primary ring-2 ring-primary/30' : ''}`} data-testid={`master-tier-${t.tier}`}>
          <p className="text-[11px] uppercase leading-tight text-muted-foreground">{t.label}{t.tier === currentTier ? ' · current' : ''}</p>
          <p className="text-2xl font-bold">{t.pct}%</p><p className="text-xs text-muted-foreground">{t.display_range}</p></div>))}</div>
      {note && <p className="text-xs text-muted-foreground">{note}</p>}
    </div>
  );
}

export function MasterSection({ section }) {
  return (
    <section className="space-y-1" data-testid={`master-section-${section.key}`}>
      <p className="text-sm font-semibold">{section.title}</p>
      <div className="overflow-x-auto rounded-lg border">
        <table className="w-full min-w-[520px] text-sm">
          <thead><tr className="border-b bg-muted/50 text-left text-[11px] uppercase text-muted-foreground"><th className="px-3 py-2">Billing item</th>{section.columns.map((c) => <th key={c} className="px-3 py-2 text-right">{c}</th>)}</tr></thead>
          <tbody>{section.rows.map((r) => <tr key={r.item} className="border-b last:border-0"><td className="px-3 py-1.5">{r.item}</td>{r.values.map((v, i) => <td key={i} className="px-3 py-1.5 text-right font-mono text-xs">{v}</td>)}</tr>)}</tbody>
        </table>
      </div>
      {section.notes?.map((n) => <p key={n} className="text-xs text-muted-foreground">{n}</p>)}
    </section>
  );
}

export function MasterScheduleView({ master, currentTier, hideTiers }) {
  if (!master) return null;
  return (
    <div className="space-y-5" data-testid="master-schedule-view">
      <div className="flex flex-wrap items-baseline justify-between gap-2">
        <div><p className="font-semibold">{master.title}</p>{master.subtitle && <p className="text-xs text-muted-foreground">{master.subtitle}</p>}</div>
        <p className="text-xs text-muted-foreground" data-testid="master-version-label">{master.version_label}{master.effective_date ? ` · effective ${master.effective_date}` : ''}</p>
      </div>
      {!hideTiers && <MasterTiers tiers={master.tiers} currentTier={currentTier} note={master.tier_note} />}
      {master.sections.map((s) => <MasterSection key={s.key} section={s} />)}
    </div>
  );
}
